import {ProductInDetailMapType, ProductInDetailSearchParamType} from "../interface";
import {Dispatch, SetStateAction} from "react";
import PaginationSub from "../../../../../components/common/pagination/PaginationSub";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import DisplayNumber from "../../../../../components/common/number/DisplayNumber";

interface PropsType {
    productDetail: ProductInDetailMapType
    tab2SearchParam: ProductInDetailSearchParamType
    setTab2SearchParam: Dispatch<SetStateAction<ProductInDetailSearchParamType>>
}

export default function Tab2({productDetail, tab2SearchParam, setTab2SearchParam}: PropsType) {

    return <div className="content_wrap">
        <h5 className="subheading mt-0">가격 정보 상세보기</h5>
        <div className="table_scroll">
            <table className="table table-bordered my_table">
                <thead>
                <tr>
                    <th style={{width: "4%"}}>No</th>
                    <th style={{width: "26%"}}>기준</th>
                    <th style={{width: "26%"}}>Pricing Group</th>
                    <th style={{width: "9%"}}>Currency</th>
                    <th style={{width: "7%"}}>Level A</th>
                    <th style={{width: "7%"}}>Level B</th>
                    <th style={{width: "7%"}}>Level C</th>
                    <th style={{width: "7%"}}>Level D</th>
                    <th style={{width: "7%"}}>Level E</th>
                </tr>
                </thead>
                <tbody>
                {productDetail.productDetailRes.productCurrencyHistoryResList.length !== 0
                    ? productDetail.productDetailRes.productCurrencyHistoryResList.map((el, idx) =>
                        <tr>
                            <td className="text-center">{idx + 1}</td>
                            <td className="text-center">{el.standard}</td>
                            <td className="text-center">{el.pricingGroup}</td>
                            <td className="text-center">{el.currency}</td>
                            <td className="text-center"><DisplayNumber value={el.levelA}/></td>
                            <td className="text-center"><DisplayNumber value={el.levelB}/></td>
                            <td className="text-center"><DisplayNumber value={el.levelC}/></td>
                            <td className="text-center"><DisplayNumber value={el.levelD}/></td>
                            <td className="text-center"><DisplayNumber value={el.levelE}/></td>
                        </tr>)
                    : <EmptyTableRow colSpan={9}/>
                }
                </tbody>
            </table>
        </div>

        <PaginationSub
            totalCount={productDetail.totalCount ?? 0}
            currentPage={tab2SearchParam.pageNo}
            onChangeCallback={(i: number) => setTab2SearchParam({...tab2SearchParam, pageNo: i})}
        />
    </div>
}